import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0124c111"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container my-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "card card-border" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Setup Your Account", -1))
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col-6",
  style: {"background-color":"#6253ff","border-radius":"12px"}
}
const _hoisted_10 = {
  class: "col-6",
  style: {"overflow":"scroll","max-height":"75vh","padding-left":"40px"}
}
const _hoisted_11 = { class: "row text-center" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, null, -1))
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_16 = { class: "my-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "avatarColor",
  class: "form-label"
}, "Avatar Color", -1))
const _hoisted_20 = { id: "colorPicker" }
const _hoisted_21 = ["id", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Email", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-group mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name", -1))
const _hoisted_27 = ["v-model"]
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "form-group mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name", -1))
const _hoisted_31 = ["v-model"]
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "form-group mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "address",
  class: "form-label"
}, "Address", -1))
const _hoisted_35 = ["v-model"]
const _hoisted_36 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_37 = { class: "form-group mb-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "City", -1))
const _hoisted_39 = ["v-model"]
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = { class: "form-group mb-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "form-label"
}, "Province/State", -1))
const _hoisted_43 = ["v-model"]
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = { class: "form-group mb-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "form-label"
}, "Country", -1))
const _hoisted_47 = ["v-model"]
const _hoisted_48 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_49 = { class: "form-group mb-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "postalCode",
  class: "form-label"
}, "Postal Code", -1))
const _hoisted_51 = ["v-model"]
const _hoisted_52 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_53 = { class: "card-footer text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/logout')))
            }, " Cancel ")
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "/goatnotes_logo.svg" })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.state.firstName != '' || _ctx.state.lastName != '')
                      ? (_openBlock(), _createBlock(_component_avatar, {
                          key: 0,
                          "avatar-size": 5,
                          initials: _ctx.state,
                          class: "m-5"
                        }, null, 8, ["initials"]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_15
                ]),
                _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.state.firstName) + " " + _toDisplayString(_ctx.state.lastName), 1),
                _hoisted_17,
                (_ctx.state.firstName != '' || _ctx.state.lastName != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "color-picker",
                            key: index,
                            id: color,
                            style: _normalizeStyle(`background-color: ${color}; border: ${
                        color == _ctx.pickedColor
                          ? '2px solid grey'
                          : '2px solid transparent'
                      }`),
                            onClick: ($event: any) => (_ctx.selectColor(color))
                          }, null, 12, _hoisted_21))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.currentEmail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("input", {
                      type: "email",
                      class: "form-control form-control-solid input-width",
                      id: "email",
                      value: _ctx.currentEmail,
                      readonly: ""
                    }, null, 8, _hoisted_24)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "firstName",
                  "v-model": _ctx.state.firstName,
                  onInput: _cache[1] || (_cache[1] = 
                    (e) => {
                      this.state.firstName = e.target.value;
                    }
                  ),
                  placeholder: "First name"
                }, null, 40, _hoisted_27),
                (_ctx.v$.firstName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.v$.firstName.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "lastName",
                  "v-model": _ctx.state.lastName,
                  onInput: _cache[2] || (_cache[2] = 
                    (e) => {
                      this.state.lastName = e.target.value;
                    }
                  ),
                  placeholder: "Last name"
                }, null, 40, _hoisted_31),
                (_ctx.v$.lastName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.v$.lastName.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "address",
                  "v-model": _ctx.state.address,
                  onChange: _cache[3] || (_cache[3] = 
                    (e) => {
                      this.state.address = e.target.value;
                    }
                  ),
                  placeholder: "Address"
                }, null, 40, _hoisted_35),
                (_ctx.v$.address.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.v$.address.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "city",
                  "v-model": _ctx.state.city,
                  onChange: _cache[4] || (_cache[4] = 
                    (e) => {
                      this.state.city = e.target.value;
                    }
                  ),
                  placeholder: "City"
                }, null, 40, _hoisted_39),
                (_ctx.v$.city.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.v$.city.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "state",
                  "v-model": _ctx.state.state,
                  placeholder: "Province/State",
                  maxlength: "2",
                  onChange: _cache[5] || (_cache[5] = 
                    (e) => {
                      this.state.state = e.target.value;
                    }
                  )
                }, null, 40, _hoisted_43),
                (_ctx.v$.state.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.v$.state.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "country",
                  "v-model": _ctx.state.country,
                  placeholder: "Country",
                  onChange: _cache[6] || (_cache[6] = 
                    (e) => {
                      this.state.country = e.target.value;
                    }
                  )
                }, null, 40, _hoisted_47),
                (_ctx.v$.country.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.v$.country.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-solid input-width",
                  id: "postalCode",
                  "v-model": _ctx.state.postalCode,
                  placeholder: "Postal code",
                  onChange: _cache[7] || (_cache[7] = 
                    (e) => {
                      this.state.postalCode = e.target.value;
                    }
                  )
                }, null, 40, _hoisted_51),
                (_ctx.v$.postalCode.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.v$.postalCode.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitAccount && _ctx.submitAccount(...args)))
          }, " Continue ")
        ])
      ])
    ])
  ]))
}